'use client';

import { useParams } from 'react-router-dom';
import UserPostsPage from '../../components/user-posts-page';

/**
 * SPA 用户公开帖：`/user/:uid`，复用 UserPostsPage。
 */
export default function SpaUserPostsPage() {
  const params = useParams();
  const uid = Number(params.uid);

  if (!Number.isInteger(uid) || uid <= 0) {
    return (
      <main className="spa-boot" role="alert">
        <h1>用户不存在</h1>
        <p>
          <a href="/">返回首页</a>
        </p>
      </main>
    );
  }

  return <UserPostsPage key={uid} uid={uid} />;
}
